module.exports = __webpack_public_path__ + "img/estrutura.87a19e43.jpg";